export const serverIp = 'api-whatsapp.fexe.co';
export const serverUrl = `https://${serverIp}`;
export const serverSocket = `wss://${serverIp}`;
export const PbxProtocol = 'https';
export const pbxServerUrl = 'https://pbx.fexe.co';
export const whatsappLogo = `${pbxServerUrl}/media/company/logo/whatsapp.svg`;
export const FexIALogo = '/static/images/fexia.jpg';
export const urlApiFexIaTracker = 'https://api-fexeia.fexe.co/agent-process/trace';
export const whatsappBlockedLogo = `${pbxServerUrl}/media/company/logo/WhatsApp_blocked.jpg`;
export const secretKey = 's1pM0v1lN0v13mbr3';
export const version = '3.0.4';

export const voiceAgentSsoSecret = 'v0z1a-sso-s1st3m4s-s4t3l1t4l3s';
